const SET_REQUESTS = (state, requests) => {
  state.requests = requests;
};

const SET_THREAD = (state, thread) => {
  state.thread = thread;
};

const SET_THREAD_MSGS = (state, threadMessages) => {
  state.threadMessages = threadMessages;
};

const UPDATE_THREAD_MSGS = (state, threadMessage) => {
  state.threadMessages.push(threadMessage);
};

export default {
  SET_REQUESTS,
  SET_THREAD,
  SET_THREAD_MSGS,
  UPDATE_THREAD_MSGS
};
